<template>
  <el-menu router :default-active="activeIndex" menu-trigger="click" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" mode="vertical" style="height: 100%">
    <div class="logo-box">
      <!-- <img src="../assets/mylogo.png" /> -->
      <img :src="userCompany.companyLogoPath" />
      <h1>{{ userCompany.companyName }}</h1>
    </div>
    <!--    <el-menu-item v-if="userRole.authority == 0" index="/control">配置中心</el-menu-item>-->
    <el-menu-item v-if="userRole.authority <= 2" index="/live">分屏监控</el-menu-item>
    <el-menu-item v-if="userRole.authority <= 2" index="/historicalAlarm">历史报警记录</el-menu-item>
    <el-menu-item v-if="userRole.authority == 0" index="/dept">公司管理</el-menu-item>
    <el-menu-item v-if="userRole.authority == 0" index="/shipManage">船舶管理</el-menu-item>
    <el-menu-item v-if="userRole.authority <= 2" index="/user">用户管理</el-menu-item>
    <el-menu-item v-if="userRole.authority == 0" index="/videoManage">摄像头管理</el-menu-item>
    <el-menu-item v-if="userRole.authority == 0" index="/alarmManage">告警管理</el-menu-item>
    <el-menu-item v-if="userRole.authority <= 2" index="/managementInterface">管理界面</el-menu-item>
    <el-menu-item v-if="userRole.authority <= 2" index="/shipPosition">船舶定位</el-menu-item>
    <!-- <el-menu-item v-if="userRole.authority <= 2" index="/map">船舶定位</el-menu-item> -->
    <!-- <el-menu-item v-if="userRole.authority == 0" index="/deviceList">国标设备</el-menu-item> -->
    <!-- <el-menu-item index="/pushVideoList">推流列表</el-menu-item> -->
    <!--    <el-menu-item index="/streamProxyList">拉流代理</el-menu-item>-->
    <!--    <el-menu-item index="/cloudRecord">云端录像</el-menu-item>-->
    <!--    <el-menu-item index="/mediaServerManger">节点管理</el-menu-item>-->
    <!--    <el-menu-item index="/parentPlatformList/15/1">国标级联</el-menu-item>-->
    <!--    <el-menu-item index="/role">角色权限</el-menu-item>-->
    <!--    <el-menu-item @click="openDoc">在线文档</el-menu-item>-->
  </el-menu>
</template>

<script>
import config from '@/utils/config.js';
export default {
  name: 'UiAside',
  data() {
    return {
      activeIndex: this.$route.path,
      userRole: '',
      userCompany: {}
    };
  },
  created() {
    if (this.$route.path.startsWith('/channelList')) {
      this.activeIndex = '/deviceList';
    }
    this.userRole = JSON.parse(sessionStorage.getItem('userRole'));
    this.userCompany = JSON.parse(sessionStorage.getItem('userCompany'));
    this.userCompany.companyLogoPath = config.API_ROOT + '/' + this.userCompany.companyLogoPath;
  },
  activated() {
    this.activeIndex = '';
    this.$nextTick(() => {
      this.activeIndex = this.$route.path;
    });
  }
};
</script>

<style scoped>
.logo-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 2px;
}
.logo-box img {
  width: 38px;
  height: 38px;
  border-radius: 5%;
}
.logo-box h1 {
  margin: 18px 3px;
  font-size: 18px;
  color: white;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/layout/UiAside.vue